import React from 'react';
import CommentsList from "../core/comments/CommentsList";
import {Box, Container, Paper} from "@material-ui/core";
import CommentForm from "./CommentForm";
import ShipmentDetailsCard from "../page-single-shipment-details/ShipmentDetailsCard";
import {useParams} from "react-router-dom";

const CommunicatorCreateCommentComponents: React.FC<{ formRef: any }> = ({formRef}) => {

    const {uuid, shipmentId} = useParams();

    return (
        <Container>
            {uuid &&<ShipmentDetailsCard uuid={uuid}/>}

            <Paper>
                <Box m={2}>
                    <CommentForm formRef={formRef}/>
                </Box>
            </Paper>

            <CommentsList shipmentId={shipmentId} withCommentDetails/>
        </Container>
    );
};

export default CommunicatorCreateCommentComponents;